/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Product/UnitsOfMeasure',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Product/ProductService'
], function ($, _, Roc, ProductService) {
    'use strict';

    var selectors = {
        unitsOfMeasurePanel: '#unitsOfMeasure',
        selectedUnitOfMeasure: '#selectedUom'
    }

    var selectedUomAfterSelectionsUpdate;

    /**
     * getUnitsOfMeasureInfoForProduct(productId) returns an object 
     * containing unit of measure info ready for rendering in the unitsOfMeasure-Tmp template.
     */
    function getUnitsOfMeasureInfoForProduct(productViewModel) {
        if (productViewModel) {
            var selectedUomId = productViewModel.productPricing && productViewModel.productPricing.unitOfMeasure
                ? productViewModel.productPricing.unitOfMeasure.id
                : $(selectors.selectedUnitOfMeasure).val();
            return {
                productId: productViewModel.id,
                unitsOfMeasure: productViewModel.availableUnitsOfMeasure,
                selectedUomId: selectedUomId || null
            };
        }
        return null;
    }

    function reloadAvailableUnitsOfMeasure(productViewModel) {
        var units = getUnitsOfMeasureInfoForProduct(productViewModel);
        render(units).then(function () {
            //On Group product page in order to preselect UoM we need to wait for selections to be updated
            if (selectedUomAfterSelectionsUpdate && productViewModel.productType == 'Simple') {
                $(selectors.selectedUnitOfMeasure).val(selectedUomAfterSelectionsUpdate);
                processUnitChangeEvent();
                selectedUomAfterSelectionsUpdate = null;
            }
        });
    }

    function render(options) {
        return Roc.UI.renderFormTemplate('unitsOfMeasure-Tmp', options, $(selectors.unitsOfMeasurePanel));
    }

    function bindUnitChange() {
        Roc.UI.siteBody
            .off('change', selectors.selectedUnitOfMeasure)
            .on('change', selectors.selectedUnitOfMeasure, function () {
                processUnitChangeEvent();
            });
    }

    function processUnitChangeEvent() {
        var $uom = $(selectors.selectedUnitOfMeasure);
        var selectedUomId = $uom.val() || "";
        var productId = $uom.attr('data-roc-productId');
        ProductService.getByIdAndUom(productId, selectedUomId)
            .then(function (product) {
                Roc.EventManager.notify(Roc.Events.products.SELECTIONS_UPDATE, product);
            });
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadAvailableUnitsOfMeasure);
        bindUnitChange();
    }

    function init(options) {
        if (options && options.uomId) {
            if (!options.hasSelections) {
                $(selectors.selectedUnitOfMeasure).val(options.uomId);
                processUnitChangeEvent();
            } else {
                //after selections will be updated on group product page
                //and uom selection will be rendered we will update uom on a simple product
                selectedUomAfterSelectionsUpdate = options.uomId;
            }
        }

        bindEvents();
    }

    var UnitsOfMeasure = {
        init: init,
        getUnitsOfMeasureInfoForProduct: getUnitsOfMeasureInfoForProduct
    }

    Roc.Logger.debug('UnitsOfMeasure.js Loaded:', UnitsOfMeasure);

    return UnitsOfMeasure;
});
